export enum ButtonVariants {
  MAIN = 'main',
  SECONDARY = 'secondary',
  CANCEL_OUTLINED = 'cancel_outlined',
  TRANSPARENT = 'transparent',
}
